<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Babies Hospital of New York</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head" id="For">F<span class="small">OREWORD</span></p>
<p class="para1">The Babies Hospital of New York is a profound institution with an extraordinary legacy. Founded by five inspiring women over 130 years ago, their stories and vision set the institution on a path to excellence in care and innovation for children and in medicine in general. So many relevant firsts in pediatrics derive from work done at and ideas originating from the Babies Hospital. The discovery of many diseases, diagnostics, and treatments, as well as the training of so many leaders and visionaries in children’s health, are part of the history of the hospital. Although the institution now bears a different name, the legacy of Babies stands strong and is a story worth telling. As the chair of the Department of Pediatrics at Columbia University and the physician in chief of the Children’s Hospital, which traces back to Babies Hospital, I have had the privilege of learning of its contributions and past. I have reviewed annual reports dating back to the very beginning, many of which have been digitized and are publicly available on the website of the Long Library Archives &amp; Special Collections. If there is one thing that has from my perspective always been present, it is a deep sense of mission, which from its inception was to relieve “mental and physical distress” and to never refuse a patient even if prospects were considered “hopeless.” This has resulted in an institution and community of tremendous courage, commitment, camaraderie, and heart. I thank you for taking the time to learn about the Babies Hospital through the collected, preserved images and vignettes assembled on these pages. I hope the profound mission and heart emerge as they both remain relevant, palpable, inspiring, and vibrant to this day.</p>
<p class="right">—Jordan Orange, MD, PhD<br/>Reuben S. Carpentier Professor of Pediatrics; chair, Department of Pediatrics, Columbia University Irving Medical Center</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?056c1782